import React from "react";

export function StockYahooFinanceToggle({ panelOpen, onToggle, connected, userId }) {
  if (!userId) return null;

  return (
    <button
      type="button"
      className={`btn btn-sm btn-primary-outline${panelOpen ? " active" : ""}`}
      onClick={onToggle}
      aria-expanded={panelOpen}
      aria-controls="stock-yahoo-panel-body"
      title={
        connected
          ? "Yahoo Finance connected — expand to manage"
          : "Connect Yahoo Finance to refresh buy recommendations"
      }
      style={{ marginBottom: 2, flexShrink: 0 }}
    >
      Yahoo Finance {panelOpen ? "▾" : "▸"}
    </button>
  );
}

export function StockYahooFinancePanelBody({
  connected,
  updatedAt,
  loading,
  loginSessionId,
  showManualImport,
  setShowManualImport,
  manualCookiesJson,
  setManualCookiesJson,
  authNotice,
  setAuthNotice,
  handleConnect,
  handleCompleteLogin,
  handleCancelLogin,
  handleDisconnect,
  handleSaveManualCookies,
  userId,
}) {
  if (!userId) {
    return (
      <div className="panel" style={{ marginBottom: 12 }}>
        <p className="panel-hint" style={{ margin: 0 }}>
          Sign in to connect your Yahoo Finance account for buy recommendation refresh.
        </p>
      </div>
    );
  }

  return (
    <section
      className="card"
      style={{ marginBottom: 16, padding: "12px 16px" }}
      aria-labelledby="stock-yahoo-heading"
    >
      <h3 id="stock-yahoo-heading" style={{ margin: "0 0 8px", fontSize: 15 }}>
        Yahoo Finance
      </h3>
      <p style={{ margin: "0 0 12px", fontSize: 14, color: "#57606a" }}>
        Buy recommendation refresh uses your personal Yahoo Finance session. Each user connects their own
        account; credentials are not shared across tenants or users.
      </p>

      {authNotice ? (
        <div
          role="alert"
          style={{
            marginBottom: 12,
            padding: "10px 12px",
            background: "#fff8e5",
            border: "1px solid #d4a72c",
            borderRadius: 6,
            fontSize: 14,
            color: "#24292f",
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "space-between",
            gap: 12,
          }}
        >
          <span>{authNotice}</span>
          <button type="button" className="btn btn-sm btn-secondary" onClick={() => setAuthNotice("")}>
            Dismiss
          </button>
        </div>
      ) : null}

      <div id="stock-yahoo-panel-body">
        {connected ? (
          <div style={{ display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
            <span style={{ color: "#1a7f37", fontWeight: 500 }}>Your Yahoo Finance session is connected</span>
            {updatedAt ? (
              <span style={{ fontSize: 13, color: "#6e7681" }}>
                Updated {new Date(updatedAt).toLocaleString()}
              </span>
            ) : null}
            <button
              type="button"
              className="btn btn-sm btn-outline-secondary"
              onClick={handleDisconnect}
              disabled={loading}
            >
              {loading ? "Disconnecting…" : "Disconnect"}
            </button>
            <button
              type="button"
              className="btn btn-sm btn-outline-primary"
              onClick={handleConnect}
              disabled={loading}
            >
              Reconnect
            </button>
          </div>
        ) : (
          <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
              <button
                type="button"
                className="btn btn-sm btn-primary"
                onClick={handleConnect}
                disabled={loading}
              >
                {loading ? "Starting…" : "Connect your Yahoo Finance account"}
              </button>
              <span style={{ fontSize: 13, color: "#6e7681" }}>
                Opens Yahoo Finance login in a server browser window.
              </span>
            </div>

            {loginSessionId ? (
              <div style={{ display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
                <button
                  type="button"
                  className="btn btn-sm btn-primary"
                  onClick={handleCompleteLogin}
                  disabled={loading}
                >
                  {loading ? "Saving…" : "Save session"}
                </button>
                <button
                  type="button"
                  className="btn btn-sm btn-secondary"
                  onClick={handleCancelLogin}
                  disabled={loading}
                >
                  Cancel
                </button>
              </div>
            ) : null}

            <button
              type="button"
              className="btn btn-sm btn-link"
              style={{ alignSelf: "flex-start", padding: 0 }}
              onClick={() => setShowManualImport((v) => !v)}
            >
              {showManualImport ? "Hide manual cookie import" : "Import cookies manually instead"}
            </button>

            {showManualImport ? (
              <div>
                <p style={{ margin: "0 0 8px", fontSize: 13, color: "#57606a" }}>
                  Log in to Yahoo Finance in your browser, export cookies for finance.yahoo.com as JSON (same
                  format as server/data/yahoo-finance-cookies.example.json), and paste below.
                </p>
                <textarea
                  className="form-control"
                  rows={5}
                  value={manualCookiesJson}
                  onChange={(e) => setManualCookiesJson(e.target.value)}
                  placeholder='[{"name":"...","value":"...","domain":".yahoo.com","path":"/"}]'
                  style={{ width: "100%", fontFamily: "monospace", fontSize: 12, marginBottom: 8 }}
                />
                <button
                  type="button"
                  className="btn btn-sm btn-primary"
                  onClick={handleSaveManualCookies}
                  disabled={loading}
                >
                  {loading ? "Saving…" : "Save cookies"}
                </button>
              </div>
            ) : null}
          </div>
        )}
      </div>
    </section>
  );
}
